export default __webpack_public_path__ + "static/media/ic_login_config.ab4df320.svg";